import Vue from 'vue';
import Vuex from 'vuex';
import { encryptUser } from './components/shared/service/authService';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cartProducts: [],
    configData: {},
    loggedUser: {},
    facebookOauth2Data: {},
    googleOauth2Data: {},
  },
  getters: {
    cartProducts: (state) => {
      return state.cartProducts;
    },
    configData: (state) => {
      return state.configData; 
    },
    getLoggedUser: (state) => {
      return state.loggedUser;
    },
    getFacebookUser: (state) => {
      return state.facebookOauth2Data;
    },
    getGoogleUser: (state) => {
      return state.googleOauth2Data;
    },
  },
  mutations: {
    ADD_CART_LOCAL: (state, product) => {
      state.cartProducts.push(product);
      localStorage.setItem('iki-cart', JSON.stringify(state.cartProducts));
    },
    ADD_LOGGED_USER: (state, user) => {
      state.loggedUser = user;
      localStorage.setItem('_auth', encryptUser(user));
    },
    SET_CART_PRODUCTS: (state, products) => {
      state.cartProducts = [];
      state.cartProducts = products;
    },
    SET_FACEBOOK_OAUTH_DATA: (state, facebookData) => {
      state.facebookOauth2Data = facebookData;
    },
    SET_GOOGLE_OAUTH_DATA: (state, googleData) => {
      state.googleOauth2Data = googleData;
    },
    SET_CONFIG_DATA: (state, configData) => {
      state.configData = configData;
    }
  },
  actions: {},
});
